var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'layout-desktop':!_vm.browser.isH5,'layout-mobile':_vm.browser.isH5}},[_c('GlobalHeader'),_c('section',{staticClass:"dom_el",class:{'ld-body': !_vm.browser.isH5,'lm-body':_vm.browser.isH5},attrs:{"id":"dom_el"}},[_c('router-view'),_c('GlobalFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }